import { OPTIONS } from './types';
import defaults from './defaults';

const initialState = {
    default: defaults
};

const reducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case OPTIONS.DEBUG_ON:
            return {
                ...state,
                default: {
                    ...state.default,
                    debug: true
                }
            };
        case OPTIONS.DEBUG_OFF:
            return {
                ...state,
                default: {
                    ...state.default,
                    debug: false
                }
            };
        default:
            return state;
    }
};

export default reducer;
